import { Location } from "history";

export default function generateLocation(url: string): Location {
  const [pathnameAndSearch, hash] = url.split("#");
  const [pathname, search] = pathnameAndSearch.split("?");

  return {
    pathname,
    search: search ? `?${search}` : "",
    hash: hash ? `#${hash}` : "",
    state: null,
  };
}
